import lang from './lang/bs-BA.js'
import { makeInitChat } from './makeInitChat.js'
export const initChat = makeInitChat(lang, import.meta.url)
